import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Box,
  Container,
  makeStyles,
  Typography,
  LinearProgress
} from '@material-ui/core';

import { actions, CONSTANTS } from 'src/redux';
import Page from 'src/components/Page';
import Results from './Results';
import Toolbar from './Toolbar';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const MenuListView = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const { listMenu } = useSelector((state) => state.menu);

  const handleRemove = (id) => {
    dispatch(actions.menu.deleteMenu.remove(id));
  };

  const handleChangePage = (newPage) => {
    const actualPage = newPage + 1;
    setPage(actualPage);
    dispatch(actions.menu.listMenu.list(actualPage));
  };

  useEffect(() => {
    dispatch(actions.menu.listMenu.list(page));
  }, []);

  return (
    <Page className={classes.root} title="Customers">
      <Container maxWidth={false}>
        <Toolbar />
        <Typography color="textPrimary" gutterBottom variant="h3">
          Items de Menu
        </Typography>
        {listMenu.status === CONSTANTS.STATUS.DONE ? (
          <Box mt={3}>
            <Results
              menus={listMenu.menus}
              page={page - 1}
              totalMenus={listMenu.totalMenus}
              onRemove={handleRemove}
              onChangePage={handleChangePage}
            />
          </Box>
        ) : (
          <LinearProgress />
        )}
      </Container>
    </Page>
  );
};

export default MenuListView;
